import React from 'react';
import InputText from 'components/input-text';

// Column Width
let columnWidth = 160;

// -------------------- HEADER -------------------- \\
const PhoneHeader = () => {
    return (
        <div className="column-list" style={{ width: columnWidth }}>
            Téléphone fixe
        </div>
    );
};

// -------------------- FILTER -------------------- \\
const PhoneFilter = ({ state, setState, onSearch }) => {
    return (
        <div className="column-list" style={{ width: columnWidth }}>
            <InputText
                label="Téléphone fixe"
                value={state.phone}
                onChange={e => setState({ ...state, phone: e.target.value })}
                onKeyPress={e => e.key === 'Enter' ? onSearch() : null}
            />
        </div>
    );
};

// -------------------- VALUE -------------------- \\
const PhoneValue = ({ value }) => {
    return (
        <div className="column-list" style={{ width: columnWidth }}>
            {value}
        </div>
    );
};

export { PhoneHeader, PhoneFilter, PhoneValue };
